export default {
  nav: {
    main: 'Hoved',
    ordersAndInvoices: 'Ordrer og fakturaer',
    drafts: 'Utkast',
    automation: 'Automatisering',
    workspace: 'Arbeidsområde',
    templates: 'Maler',
    delivery: 'Levering',
    settings: 'Innstillinger',
    shippingLabels: 'Fraktetiketter',
    subscriptions: 'Abonnementer',
    support: 'Støtte',
    developer: 'Utvikler',
    writeReview: 'Skriv en anmeldelse',
    supportTicket: 'Støtteforespørsel',
    welcomeTour: 'Velkomstomvisning',
    administratorConsole: 'Administratorkonsoll',
    logout: 'Logg ut',
  },
  dashboard: {
    pageTitle: 'Ordrer og fakturaer',
    pageDescription: 'Manage your orders and invoices',
    title: 'Ordrer og fakturaer',
    selectedOrders: '{count} valgte ordrer',
    completed: '% fullført',
    processing: 'Behandler, vennligst vent...',
    bulkDownload: 'Massenedlasting',
    upgradeBulkDownload: 'Oppgrader planen din for massenedlasting',
    showFilters: 'Vis filtre',
    hideFilters: 'Skjul filtre',
    creatingInvoices: 'Oppretter fakturaer, vennligst vent...',
    bulkCreateInvoices: 'Masseoppretting av fakturaer',
    cannotCreateAutopilot: 'Du kan ikke opprette fakturaer manuelt når faktureringsmodus er på autopilot.',
    exportInvoices: 'Eksporter fakturaer eller ordrer',
    capturePayments: 'Registrer betalinger manuelt',
    filterOrders: 'Filtrer ordrer',
    error: 'Beklager, noe gikk galt...',
    close: 'Lukk',
    chooseDate: 'Velg en dato',
    chooseIssueDate: 'Velg en utstedelsesdato for de valgte fakturaene',
    cancel: 'Avbryt',
    createInvoices: 'Opprett fakturaer',
    storno: 'Storno',
    bulkOrderCapture: 'Masseregistrering av ordrer',
  },
  search: {
    createdBetween: 'Opprettet mellom',
    modifiedBetween: 'Endret mellom',
    orderNumber: 'Ordre #',
    invoiceNumber: 'Faktura #',
    refundNumber: 'Refusjon #',
    customer: 'Kunde',
    payment: 'Betaling',
    any: 'Alle',
    authorized: 'Autorisert',
    pending: 'Venter',
    paid: 'Betalt',
    partiallyPaid: 'Delvis betalt',
    refunded: 'Refundert',
    voided: 'Annullert',
    partiallyRefunded: 'Delvis refundert',
    unpaid: 'Ubetalt',
    fulfillment: 'Oppfyllelse',
    fulfilled: 'Sendt',
    partial: 'Delvis',
    unfulfilled: 'Ikke sendt',
    loading: 'Laster ordrer...',
    search: 'Søk',
  },
  orderList: {
    noCustomer: 'Ingen kunde',
    downloadOrder: 'Last ned ordre',
    deleteWarning: 'Viktig! Dette vil slette alle fakturaer og refusjoner opprettet etter datoen:',
    includingInvoice: 'inkludert den valgte fakturaen #',
    pressOk: 'Trykk OK for å fortsette eller Avbryt for å avbryte.',
    cannotCreateAutopilot: 'Du kan ikke opprette fakturaer manuelt når faktureringsmodus er på autopilot.',
    createInvoice: 'Opprett faktura for denne ordren',
    create: 'Opprett',
    addCreditNote: 'Legg til kreditnota',
    createStorno: 'Opprett en stornofaktura',
    refund: 'Refusjon',
    downloadInvoice: 'Last ned denne fakturaen',
    download: 'Last ned',
    default: 'Standard',
    downloadStorno: 'Last ned denne stornoen/kreditnotaen',
    fulfillOrder: 'Oppfyll ordre',
    orderNum: 'Ordre #',
    locPrefix: 'Lok-prefiks',
    invoiceNum: 'Faktura #',
    refundNum: 'Refusjon #',
    customerCol: 'Kunde',
    orderCreatedDate: 'Ordre opprettet dato',
    orderModifiedDate: 'Ordre endret dato',
    delivered: 'Levert',
    paymentStatus: 'Betalingsstatus',
    fulfillmentStatus: 'Forsendelsestatus',
    totalOutstanding: 'Totalt utestående beløp',
    originalPrice: 'Opprinnelig pris',
    noOrders: 'Butikken din har ingen ordrer for den valgte statusen.',
    cannotCreateNoOrders: 'Du kan ikke opprette fakturaer når det ikke finnes ordrer.',
    createOrdersFirst: 'Vennligst opprett minst én ordre og prøv igjen.',
    createOrders: 'Opprett ordrer',
    loadingOrders: 'Laster...',
    paidManual: 'Betalt - Manuell',
    paid: 'Betalt',
    refunded: 'Refundert',
    pending: 'Venter',
    partiallyPaid: 'Delvis betalt',
    partiallyRefunded: 'Delvis refundert',
    fulfilled: 'Sendt',
    unfulfilled: 'Ikke sendt',
    deliveryPending: 'Venter',
    deliverNow: 'Lever nå',
    deliveryPartial: 'Delvis',
    notDelivered: 'Ikke levert',
    deliverAgain: 'Lever igjen',
    deliveryDetails: 'Leveringsdetaljer',
    deliveryFailed: 'Levering mislyktes',
    sent: 'Sendt',
    failed: 'Mislyktes',
    toLabel: 'Til',
    folderLabel: 'Mappe',
    open: 'Åpen',
    invoice: 'Faktura',
    creditNote: 'Kreditnota',
    stornoLabel: 'Storno',
    unknown: 'Ukjent',
    googleDrive: 'Google Drive',
    clientsTablet: 'Klientnettbrett',
    shippyPro: 'ShippyPro',
    emailChannel: 'E-post',
    ftpChannel: 'FTP',
    revertToDate: 'Tilbakestill til denne datoen',
    add: 'Legg til',
    close: 'Lukk',
  },
  downloadDialog: {
    downloadType: 'Last ned {type}...',
    selectTemplate: 'Velg en mal fra galleriet for å eksportere ordrer, fakturaer, stornofakturaer eller kreditnotaer.',
    getMoreTemplates: 'Hent flere maler',
    createNewTemplate: 'Opprett en ny mal',
    allCreatedBetween: 'Alle opprettede {type} mellom',
    selectedType: 'Valgte {type}',
    and: 'og',
    status: 'Status',
    any: 'Alle',
    open: 'Åpen',
    closed: 'Lukket',
    cancelled: 'Kansellert',
    paymentStatus: 'Betalingsstatus',
    fulfillmentStatus: 'Forsendelsestatus',
    fulfilled: 'Sendt',
    partial: 'Delvis',
    unfulfilled: 'Ikke sendt',
    authorized: 'Autorisert',
    pending: 'Venter',
    paid: 'Betalt',
    partiallyPaid: 'Delvis betalt',
    refunded: 'Refundert',
    voided: 'Annullert',
    partiallyRefunded: 'Delvis refundert',
    unpaid: 'Ubetalt',
    format: 'Format',
    forLocation: 'For lokasjon',
    advancedOptions: 'Avanserte alternativer',
    exportHSCodes: 'Eksporter lager HS-koder (tregere)',
    noteChrome: 'Merk: For optimal nedlasting anbefales Chrome og deaktivering av adblocker.',
    downloadIndividually: 'Last ned enkeltvis',
    downloadGrouped: 'Last ned gruppert',
  },
  templates: {
    pageTitle: 'Maler',
    pageDescription: 'Customize your invoice templates',
    title: 'Maler',
    installTranslated: 'Installer en oversatt mal',
    installTranslatedDesc: 'Velg et annet språk ved å klikke på denne knappen.',
    createNew: 'Opprett en ny mal om nødvendig',
    createNewDesc: 'Klikk på denne knappen for å opprette en ny mal om nødvendig.',
    customize: 'Tilpass maler',
    customizeDesc: 'Klikk på standardmalen for å tilpasse den. Du kan endre logo, farger og for mer avanserte brukere, koden bak.',
    defaultTemplate: 'Faktura, storno og kreditnota (Standard)',
    logo: 'Logo',
    colorPalette: 'Fargepalett',
    getColorPalettes: 'Hent fargepaletter',
    paperSize: 'Papirstørrelse',
    format: 'Format',
    a3: 'A3 (297 x 420 mm)',
    a4: 'A4 (210 x 297 mm)',
    a5: 'A5 (148 x 210 mm)',
    legal: 'Legal (215.9 x 355.6 mm)',
    letter: 'Letter (215.9 x 279.4 mm)',
    tabloid: 'Tabloid (279.4 x 431.8 mm)',
    mcPrint3: 'mC-Print3 Roll (80 x 155 mm)',
    mcPrint2: 'mC-Print2 Roll (57.5 x 155 mm)',
    orientation: 'Orientering',
    landscape: 'Liggende',
    portrait: 'Stående',
    margin: 'Marg (cm)',
    unsavedChanges: 'Ulagrede endringer',
    discard: 'Forkast',
    save: 'Lagre',
  },
  labels: {
    pageTitle: 'Fraktetiketter',
    pageDescription: 'Create and manage shipping labels',
    title: 'Fraktetiketter',
    glsRequiresPro: 'GLS fraktetiketter for EEU krever Professional-planen.',
    upgradeDesc: 'Oppgrader til Professional for å opprette og administrere fraktetiketter.',
    upgradePlan: 'Oppgrader planen din',
    eeuGls: 'EEU GLS',
    enabled: 'Aktivert',
    country: 'Land',
    hungary: 'Ungarn',
    slovakia: 'Slovakia',
    czech: 'Tsjekkia',
    romania: 'Romania',
    slovenia: 'Slovenia',
    croatia: 'Kroatia',
    senderId: 'Avsender-ID',
    username: 'Brukernavn',
    password: 'Passord',
    name: 'Navn',
    city: 'By',
    address: 'Adresse',
    zipCode: 'Postnummer',
    contactPerson: 'Kontaktperson',
    phone: 'Telefon',
    email: 'E-post',
    glsServices: 'GLS-tjenester',
    expressService: 'Ekspresstjeneste',
    exchangeService: 'Byttetjeneste',
    smsService: 'SMS-tjeneste',
    smsText: 'SMS-tekst',
    preAdviceService: 'Forhåndsvarslingstjeneste',
    unsavedChanges: 'Ulagrede endringer',
    discard: 'Forkast',
    save: 'Lagre',
  },
  billing: {
    pageTitle: 'Fakturering',
    pageDescription: 'Manage your subscription and billing',
    title: 'Fakturering',
    subscriptionFor: 'Abonnementsplan for butikk',
    currentlySubscribed: 'Du abonnerer for øyeblikket på',
    plan: 'plan',
    cancelSubscription: 'Avbryt abonnement',
    upgradePlan: 'Oppgrader planen din',
    professional: 'Professional',
    proPriceMonthly: '$29.99 / måned',
    upgrade: 'Oppgrader',
    includesAllStarter: 'Inkluderer alle Starter-funksjoner, pluss:',
    proFeature1: 'Global samsvarspakke: Stedsbaserte prefikser og tilpasset sekvensiell nummerering',
    proFeature2: 'Smart lokalisering: Automatisk oversatte e-poster og lokaliserte PDF-vedlegg',
    proFeature3: 'Komplett B2B-dokumentlivssyklus: Proformaer, B2B-tilbud og kreditnotaer',
    proFeature4: 'B2B regnskapssynkronisering: 3-desimalers enhetspresisjon og flervalutavisning',
    proFeature5: 'Automatiserte sikkerhetskopier: Kopier fakturaer automatisk til sikker FTP eller Google Drive',
    proFeature6: 'Shopify Flow: Automatiser fakturagenerering, levering og storno via Flow-utløsere og handlinger',
    proFeature7: 'Avansert AI-logikk: Bruk AI på enheten for komplekse betingede layoutklausuler',
    proFeature8: 'UBL XML og ZUGFeRD / Factur-X eksport (europeisk e-fakturaoverholdelse)',
    proFeature9: 'EPC QR-koder for umiddelbare mobile POS-betalinger',
    proFeature10: 'GLS fraktetiketter for EEU',
    proFeature11: '7 års skattemessig oppbevaring for samsvar',
    currentlyUsing: 'Du bruker for øyeblikket vår',
    free: 'gratis',
    subscriptionPlan: 'abonnementsplan.',
    monthlyUsage: 'Månedlig bruk',
    monthlyGenerated: '{count} / 50 fakturaer denne måneden',
    monthlyLimitReached: 'Månedlig grense nådd. Oppgrader til Starter for ubegrensede fakturaer.',
    freePlan: 'Gratisplan',
    freeToInstall: 'Gratis å installere',
    freeFeature1: 'Opptil 50 fakturaer/ordrer per måned',
    freeFeature2: 'Tilgang til alle 31+ forhåndsdefinerte maler',
    freeFeature3: 'Grunnleggende AI-kopilot',
    freeFeature4: 'Standard PDF-nedlastinger og utskrift',
    freeFeature5: 'Standard dokumentpakke (fakturaer, pakksedler, kvitteringer)',
    freeFeature6: '3 måneders sikker fakturaoppbevaring',
    starterPlan: 'Starterplan',
    starterPrice: '$9.99 / måned',
    starterPricePerInvoice: '+ 3¢ per opprettet faktura',
    subscribe: 'Abonner',
    starterFeature1: 'Ubegrensede fakturaer og ordrer',
    starterFeature2: 'Automatisert PDF-levering via e-post',
    starterFeature3: 'Full tilgang til hybridredigerer og AI-kopilot',
    starterFeature4: 'Shopify POS og strekkodeintegrasjon',
    starterFeature5: 'Shopify Flow: Utløsere og handlinger for fakturaautomatisering',
    starterFeature6: 'UBL XML / PEPPOL og ZUGFeRD / Factur-X eksport (e-fakturaoverholdelse)',
    starterFeature7: '1 års sikker fakturaoppbevaring',
    proTaxOverrides: 'Tilpassede skatteoverstyringer: MVA / GST per produkt og SKU-nivå satser',
    unsavedChanges: 'Ulagrede endringer',
    discard: 'Forkast',
    save: 'Lagre',
  },
  autopilot: {
    pageTitle: 'Automatisering',
    pageDescription: 'Automate invoice creation and management',
    title: 'Automatisering',
    autoCreate: 'Opprett fakturaer automatisk',
    disabled: 'Deaktivert (manuell)',
    whenCreated: 'Når ordrer opprettes',
    whenFulfilled: 'Når ordrer oppfylles',
    whenPaid: 'Når ordrer betales',
    autoCreateDesc: 'Fakturaer vil bli opprettet på datoen når ordrer opprettes, oppfylles eller betales.',
    autoStorno: 'Stornér fakturaer automatisk',
    whenCancelled: 'Når ordrer kanselleres eller refunderes',
    autoStornoDesc: 'Stornofakturaer vil bli opprettet på datoen når ordrer annulleres/kanselleres eller refusjoner opprettes.',
    cannotAutoFree: 'Automatisk oppretting av fakturaer kan ikke utføres med gratisplanen.',
    upgradePlan: 'Oppgrader planen din',
    unsavedChanges: 'Ulagrede endringer',
    discard: 'Forkast',
    save: 'Lagre',
  },
  delivery: {
    pageTitle: 'Levering',
    pageDescription: 'Configure invoice delivery via email, FTP, or Google Drive',
    title: 'Levering',
    settings: 'Innstillinger',
    useOrderNumbers: 'Bruk ordrenumre for filer',
    sendIfCountry: 'Send hvis fakturaadressens land er',
    countryCodesHint: 'List alle landskoder atskilt med semikolon.',
    sendForTags: 'Send for kunder som har en av de oppførte taggene',
    tagsHint: 'List alle tagger atskilt med semikolon.',
    emailDelivery: 'E-postlevering',
    sendAsPdf: 'Send fakturaer som PDF-vedlegg til kunder',
    autoSend: 'Send automatisk når en faktura opprettes',
    subject: 'Emne',
    body: 'Innhold',
    xmlAttachments: 'XML-vedlegg',
    attachUbl: 'Legg ved UBL/PEPPOL XML (E-Factura)',
    attachZugferd: 'Legg ved ZUGFeRD / Factur-X XML',
    sendTestEmail: 'Send test-e-post',
    sending: 'Sender...',
    customSmtp: 'Tilpasset SMTP-server',
    customSmtpDesc: 'Bruk din egen e-postserver i stedet for standardserveren',
    enableSmtp: 'Aktiver tilpasset SMTP',
    smtpHost: 'SMTP-vert',
    port: 'Port',
    useSsl: 'Bruk SSL/TLS',
    username: 'Brukernavn',
    password: 'Passord',
    fromEmail: 'Fra e-post',
    fromName: 'Fra navn',
    shopifyLiquid: 'Shopify Liquid-mal',
    pasteInto: 'Lim dette inn i din',
    orderConfirmation: 'ordrebekreftelsesmal',
    toAddLink: 'for å legge til en nedlastingslenke.',
    downloadInvoice: 'Last ned fakturaen din',
    clientsTablet: 'ClientsTablet',
    clientsTabletDesc: 'Send forespørsler til ClientsTablet når fakturaer opprettes',
    shippyPro: 'ShippyPro',
    shippyProDesc: 'Send PDF-fakturaer som tolldokumenter til ShippyPro for land utenfor EU',
    ftpBackup: 'FTP/SFTP-sikkerhetskopiering',
    ftpDesc: 'Kopier fakturaer automatisk til serveren din',
    enableFtp: 'Aktiver automatisk FTP-sikkerhetskopiering',
    host: 'Vert',
    useSftp: 'Bruk SFTP (sikker)',
    destinationFolder: 'Målmappe',
    xmlFiles: 'XML-filer',
    includeUbl: 'Inkluder UBL/PEPPOL XML (E-Factura)',
    includeZugferd: 'Inkluder ZUGFeRD / Factur-X XML',
    testConnection: 'Test tilkobling',
    testing: 'Tester...',
    pro: 'PRO',
    upgradeFtp: 'Oppgrader til Professional for å automatisk kopiere fakturaer til din FTP/SFTP-server.',
    googleDrive: 'Google Drive',
    googleDriveDesc: 'Synkroniser fakturaer automatisk til din Drive',
    connected: 'Tilkoblet',
    disconnect: 'Koble fra',
    notWorking: 'Fungerer ikke? Gå til',
    googlePermissions: 'Google-tillatelser',
    removeThenReconnect: 'fjern Invoice Browse, og koble til på nytt.',
    connectGoogleDrive: 'Koble til Google Drive',
    upgradeGoogleDrive: 'Oppgrader til Professional for å automatisk synkronisere fakturaer til Google Drive.',
    unsavedChanges: 'Ulagrede endringer',
    discard: 'Forkast',
    freePlanTitle: 'Automated delivery is not available on the free plan',
    freePlanDesc: 'Upgrade to Starter or Professional to automatically send invoices via email, FTP, or Google Drive.',
    emailLiquidTemplate: 'Email Liquid Template',
    liquidTemplateDesc: 'Copy and paste this code to your order confirmation template. Click {link} to open it.',
    here: 'here',
    save: 'Lagre',
  },
  bookkeeping: {
    pageTitle: 'Innstillinger',
    pageDescription: 'Configure your invoice settings',
    title: 'Innstillinger',
    owner: 'Eier',
    email: 'E-post',
    phone: 'Telefon',
    keepDifferentNumbering: 'Behold forskjellig fakturanummerering for hver ordrelokasjon',
    keepDifferentNumberingDisabled: 'Behold forskjellig fakturanummerering for hver ordrelokasjon er ikke et alternativ som er aktivert med din plan.',
    locationEmailDesc: 'Dette lar deg sende e-poster og fakturaer oversatt basert på ordrelokasjonen: lagerlokasjon, leveringsadresse eller fakturaadresse',
    upgradePlan: 'Oppgrader planen din',
    matchingCriteria: 'Samsvarskriterier',
    locationId: 'Lokasjons-ID',
    shippingCountryCode: 'Leveringsadressens landskode',
    billingCountryCode: 'Fakturaadressens landskode',
    matchLocationDesc: 'Match en lokasjon basert på ordrelokasjon-ID, leveringsadresse eller fakturaadressens landskode.',
    companyInfo: 'Firmainformasjon',
    name: 'Navn',
    website: 'Nettsted',
    registrationNumber: 'Registreringsnummer',
    taxId: 'Organisasjonsnummer',
    addressSection: 'Adresse',
    streetName: 'Gatenavn',
    streetNumber: 'Gatenummer',
    zip: 'Postnummer',
    city: 'By',
    region: 'Region',
    country: 'Land',
    bankingInfo: 'Bankinformasjon',
    bankName: 'Banknavn',
    swift: 'Swift',
    currency: 'Valuta',
    iban: 'IBAN',
    invoicing: 'Fakturering',
    decimalPlaces: 'Desimalplasser',
    invoicesPrefix: 'Fakturaprefiks',
    currentInvoiceNumber: 'Gjeldende fakturanummer',
    creditNotesPrefix: 'Kreditnotaprefiks',
    currentCreditNoteNumber: 'Gjeldende kreditnotanummer',
    lastInvoiceDate: 'Siste fakturadato',
    noInvoicesYet: 'Ingen fakturaer opprettet ennå.',
    confirmReverting: 'Bekreft tilbakestilling av systemet',
    allInvoicesAfter: 'Alle fakturaer og deres stornoer utstedt etter',
    willBeRemoved: 'vil bli fjernet. Fortsett med tilbakestilling av systemet?',
    cancel: 'Avbryt',
    revert: 'Tilbakestill',
    revertDesc: 'Tilbakestilling av systemet vil slette alle fakturaer opprettet etter den valgte datoen.',
    revertToDate: 'Tilbakestill til denne datoen',
    reverting: 'Tilbakestiller systemet, vennligst vent...',
    useOrderNumbering: 'Bruk ordrenummerering',
    showVat: 'Vis MVA på fakturaer',
    overrideTaxes: 'Overstyr skatter',
    pricesIncludeTax: 'Prisene inkluderer skatt',
    productsTaxRate: 'Produktskattesats',
    shippingTaxRate: 'Fraktskattesats',
    skusSeparated: 'SKUer atskilt med semikolon',
    skusTaxRate: 'SKU-skattesats',
    useOrderDates: 'Bruk ordreopprettelsesdatoer for fakturaer',
    convertCurrency: 'Konverter priser til valutaen kunden betaler i',
    unsavedChanges: 'Ulagrede endringer',
    discard: 'Forkast',
    save: 'Lagre',
  },
  drafts: {
    pageTitle: 'Utkast',
    pageDescription: 'Manage your draft orders',
    title: 'Utkast',
    download: 'Last ned',
    newDraft: 'Nytt utkast',
    exporting: 'Eksporterer {status}%...',
    accessNotGranted: 'Tilgang til utkastordrer er ikke gitt. Vennligst',
    reLogin: 'logg inn på nytt',
    toGrantPermissions: 'for å gi de nødvendige tillatelsene for "Utkastordrer".',
    pushFailed: 'Sending til Shopify feilet:',
    exportError: 'Eksportfeil:',
    confirmDelete: 'Er du sikker på at du vil slette dette utkastet?',
    incompleteCustomer: 'Kundedataene er ufullstendige:',
    pushWithoutCustomer: 'Utkastet vil bli sendt til Shopify uten kundedata. Fortsette?',
    customerNotInShopify: 'Denne kunden finnes ikke i Shopify ennå.',
    warnings: 'Advarsler:',
    createCustomerAndPush: 'Opprett kunden i Shopify og send utkastordren?',
    downloadTitle: 'Last ned utkast',
    cancel: 'Avbryt',
  },
  draftEdit: {
    number: "Nummer",
    prefix: "Prefiks",

    newDraft: 'Nytt utkast',
    editDraft: 'Rediger utkast',
    viewInShopify: 'Vis i Shopify',
    back: 'Tilbake',
    createDraft: 'Opprett utkast',
    saveChanges: 'Lagre endringer',
    documentType: 'Dokumenttype',
    draftOrder: 'Utkastordre',
    quote: 'Tilbud',
    proforma: 'Proforma',
    manualInvoice: 'Manuell faktura',
    currency: 'Valuta',
    expiryDate: 'Utløpsdato',
    status: 'Status',
    draft: 'Utkast',
    sent: 'Sendt',
    accepted: 'Akseptert',
    customer: 'Kunde',
    firstName: 'Fornavn',
    lastName: 'Etternavn',
    email: 'E-post',
    phone: 'Telefon',
    company: 'Firma',
    taxId: 'Organisasjonsnummer',
    billingAddress: 'Fakturaadresse',
    address: 'Adresse',
    aptSuite: 'Leilighet/Suite',
    city: 'By',
    province: 'Fylke',
    countryField: 'Land',
    zip: 'Postnummer',
    shippingAddress: 'Leveringsadresse',
    sameAsBilling: 'Samme som fakturaadresse',
    lineItems: 'Linjeartikler',
    shipping: 'Frakt',
    shippingTitle: 'Tittel',
    shippingPlaceholder: 'f.eks. Standardfrakt',
    price: 'Pris',
    note: 'Notat',
    notePlaceholder: 'Internt notat eller melding til kunde...',
    summary: 'Sammendrag',
    subtotal: 'Delsum',
    discounts: 'Rabatter',
    tax: 'Skatt',
    total: 'Totalt',
  },
  login: {
    pageTitle: 'Invoice Browse - Monthly batch invoicing',
    enterShopAddress: 'Skriv inn butikkadressen din',
    loginWith: 'Logg inn med',
    createAccount: 'Opprett en ny konto',
    placeholder: 'din-butikk-navn',
    shopRequired: 'Butikknavn er påkrevd',
    login: 'Logg inn',
    shopify: 'Shopify',
    terms: 'Vilkår og betingelser',
    privacy: 'Personvernerklæring',
  },
  developer: {
    pageTitle: 'Developer Tools',
    pageDescription: 'Developer tools and API configuration',
  },
  leads: {
    pageTitle: 'Leads',
    pageDescription: 'Manage your leads',
  },
  review: {
    enjoying: 'Liker du Invoice Browse?',
    description: 'Du har opprettet dine første fakturaer! Hvis du synes appen er nyttig, hjelper en rask anmeldelse på Shopify App Store oss mye.',
    reward: 'Som takk vil vi tilbakestille din månedlige bruksteller til 0',
    leaveReview: 'Skriv en anmeldelse',
    maybeLater: 'Kanskje senere',
  },
  footer: {
    copyright: '© 2026 Growth Connections',
  },
  joyride: {
    welcomeTitle: 'Velkommen til Invoice Browse',
    welcomeContent: 'La meg vise deg hvordan du kan bruke det.',
    dashboardTitle: 'Kontrollpanel',
    dashboardContent: 'Skjermen du ser er hovedkontrollpanelet. Her kan du finne alle ordrer og eksportere dem til ulike dokumenttyper som: fakturaer, pakksedler og andre.',
    automationTitle: 'Gjør livet enklere',
    automationContent: 'Aktiver automatisering for å opprette fakturaer når ordrer betales eller refunderes.',
    templatesTitle: 'Tilpass maler',
    templatesContent: 'Gå hit for å oversette malen din, tilpasse den eller opprette en ny.',
    deliveryTitle: 'Levering',
    deliveryContent: 'Konfigurer appen vår til å automatisk kopiere opprettede dokumenter til FTP, Google Drive, eller som vedlegg i e-poster.',
    settingsTitle: 'Innstillinger',
    settingsContent1: 'Juster firmaets telefonnummer, e-post og andre felt som brukes på dokumenter.',
    settingsContent2: 'Endre dokumentets startnummer eller slett dokumenter opprettet etter en dato.',
    settingsContent3: 'Overstyr MVA-satser for frakt og produkter',
    settingsContent4: 'Endre desimalplasser for tall',
    reviewTitle: 'Skriv en anmeldelse',
    reviewContent: 'Støtt teamet vårt ved å skrive oss en god anmeldelse!',
    tourTitle: 'Velkomstomvisning',
    tourContent: 'Hei, du kan åpne denne omvisningen igjen herfra.',
    createDocTitle: 'Opprett ditt første dokument',
    createDocContent: 'Klikk på Opprett-knappen for å opprette ditt første dokument.',
    docNumberTitle: 'Dokumentnummer',
    docNumberContent: 'Første dokument har nummer 1 tildelt. Hvis du vil starte med et annet nummer kan du endre dette fra Innstillinger.',
    downloadDocTitle: 'Last ned dokument',
    downloadDocContent: 'Klikk på Last ned-rullegardinmenyen og velg en dokumentmal for å eksportere ordren din som PDF.',
  },
  common: {
    save: 'Lagre',
    cancel: 'Avbryt',
    close: 'Lukk',
    discard: 'Forkast',
    delete: 'Slett',
    edit: 'Rediger',
    create: 'Opprett',
    loading: 'Laster...',
    unsavedChanges: 'Ulagrede endringer',
    upgradePlan: 'Oppgrader planen din',
  },
  languageSelector: {
    label: 'Språk',
    auto: 'Automatisk gjenkjenning',
  },
  draftList: {
    draftNum: 'Utkast #',
    shopifyId: 'Shopify ID',
    type: 'Type',
    customer: 'Kunde',
    total: 'Totalt',
    status: 'Status',
    delivered: 'Levert',
    date: 'Dato',
    actions: 'Handlinger',
    noCustomer: 'Ingen kunde',
    noDrafts: 'Ingen utkast eller tilbud funnet.',
    loading: 'Laster...',
    download: 'Last ned',
    default: 'Standard',
    pending: 'Venter',
    deliverNow: 'Lever nå',
    deliveryDetails: 'Leveringsdetaljer',
    sent: 'Sendt',
    failed: 'Mislykket',
    deliverAgain: 'Lever igjen',
    partial: 'Delvis',
    notDelivered: 'Ikke levert',
    deliveryFailed: 'Levering mislyktes',
    unknown: 'Ukjent',
    edit: 'Rediger',
    send: 'Send',
    pushToShopify: 'Send til Shopify',
    complete: 'Fullfør',
    duplicate: 'Dupliser',
    delete: 'Slett',
    quote: 'Tilbud',
    proforma: 'Proforma',
    draftOrder: 'Utkastordre',
    manualInvoice: 'Manuell faktura',
  },
  draftSearch: {
    createdBtw: 'Opprettet ml.',
    draftNum: 'Draft #',
    shopifyId: 'Shopify ID',
    customer: 'Kunde',
    status: 'Status',
    type: 'Type',
    delivery: 'Levering',
    any: 'Alle',
    draft: 'Utkast',
    sent: 'Sendt',
    accepted: 'Akseptert',
    expired: 'Utløpt',
    converted: 'Konvertert',
    cancelled: 'Kansellert',
    quote: 'Tilbud',
    proforma: 'Proforma',
    draftOrder: 'Utkastordre',
    manualInvoice: 'Manuell faktura',
    delivered: 'Levert',
    notDelivered: 'Ikke levert',
    pending: 'Venter',
    search: 'Søk',
  },
  draftDownload: {
    title: 'Last ned Utkast #...',
    selectTemplate: 'Select a template from the gallery to export drafts, quotes, or proformas.',
    allDraftsBetween: 'All drafts between',
    selectedDrafts: 'Selected drafts',
    and: 'and',
    status: 'Status',
    documentType: 'Type',
    any: 'Alle',
    draft: 'Utkast',
    sent: 'Sendt',
    accepted: 'Akseptert',
    expired: 'Utløpt',
    converted: 'Konvertert',
    cancelled: 'Kansellert',
    quote: 'Tilbud',
    proforma: 'Proforma',
    draftOrder: 'Utkastordre',
    manualInvoice: 'Manuell faktura',
    format: 'Format',
    noTemplates: 'No templates found',
    noTemplatesForType: 'No templates found for document type "{type}".',
    installTemplates: 'Install templates',
    toStartExporting: 'to start exporting.',
    noteChrome: 'Note: For optimal download Chrome browser is recommended and any Adblocker to be disabled.',
    cancel: 'Cancel',
    downloadIndividually: 'Download Individually',
    downloadGrouped: 'Download Grouped',
  },
  templateEditor: {
    pageTitle: 'Template Editor',
    pageDescription: 'Edit and customize your invoice template',
    installNewTemplate: 'Installer ny mal',
    tabStyle: 'Stil',
    tabContent: 'Innhold',
    tabTranslations: 'Oversettelser',
    tabSettings: 'Innstillinger',
    tabCode: 'Kode',
    tabCopilot: 'AI-Kopilot',
    logo: 'Logo',
    colorPalette: 'Fargepalett',
    colorText: 'Text',
    colorBg: 'BG',
    colorBorder: 'Border',
    colorPrimary: 'Primary',
    colorAccent: 'Accent',
    font: 'Font',
    fontDefault: 'Default (DM Sans)',
    fontSize: 'Font Size',
    fontSizeDefault: 'Default (11.5px)',
    fontSizeCompact: 'Compact',
    fontSizeSmall: 'Small',
    fontSizeMediumSmall: 'Medium Small',
    fontSizeMedium: 'Medium',
    fontSizeMediumLarge: 'Medium Large',
    fontSizeLarge: 'Large',
    fontSizeExtraLarge: 'Extra Large',
    documentTitle: 'Document Title',
    documentTitlePlaceholder: 'e.g. Invoice, Tax Invoice, Factura...',
    noToggleSupport: 'This template does not support toggle controls. Switch to a gallery template for full customization.',
    sections: 'Sections',
    shippingAddress: 'Shipping address',
    bankPaymentDetails: 'Bank / payment details',
    paymentStatusBadge: 'Payment status badge',
    orderNotes: 'Order notes',
    trackingFulfillment: 'Tracking / fulfillment info',
    termsConditions: 'Terms & conditions',
    signatureLines: 'Signature lines',
    qrCode: 'QR code',
    lineItems: 'Line Items',
    taxColumns: 'Tax columns (VAT / GST)',
    productSku: 'Product SKU',
    productImages: 'Product images',
    discountBreakdown: 'Discount breakdown',
    itemWeight: 'Item weight',
    hsCode: 'HS code (customs)',
    mergeDiscounts: 'Merge discounts into product price',
    showOrderDiscountAsSummary: 'Show order discount as a summary line',
    totals: 'Totals',
    subtotalBeforeTax: 'Subtotal (before tax)',
    taxBreakdownByRate: 'Tax breakdown by rate',
    shippingCostSeparate: 'Shipping cost as separate line',
    dueDate: 'Due date',
    formatting: 'Formatting',
    dateFormat: 'Date format',
    decimalPlaces: 'Decimal places',
    paymentTerms: 'Payment terms',
    paymentTermsNone: 'None',
    thankYouMessage: 'Thank you message',
    thankYouPlaceholder: 'Thank you for your business!',
    countryMatchTitle: 'Use this template when shipping or billing address matches this country',
    addressType: 'Address Type',
    addressDisabled: 'Disabled',
    addressShipping: 'Shipping Address',
    addressBilling: 'Billing Address',
    country: 'Country',
    anyCountry: 'Any country',
    countryMatchDesc: 'When enabled, this template will be used automatically for orders where the selected address matches the chosen country.',
    languagePreset: 'Language Preset',
    selectLanguage: 'Select a language...',
    languagePresetDesc: 'Selecting a language fills in all labels below. You can then customize individual fields.',
    paperSize: 'Paper Size',
    format: 'Format',
    orientation: 'Orientation',
    portrait: 'Portrait',
    landscape: 'Landscape',
    margin: 'Margin (cm)',
    template: 'Template',
    templateName: 'Name',
    systemAlias: 'System Alias',
    systemAliasDesc: 'for POS/Admin URL routes',
    systemAliasNone: 'None',
    defaultTemplate: 'Default template',
    defaultTemplateDesc: 'Used for direct links shared with customers.',
    posRouteDesc: 'Maps to /template/[alias]/receipt.pdf for POS integration.',
    documentType: 'Document Type',
    invoiceCreditNote: 'Invoice + Credit Note',
    order: 'Order',
    invoiceOnly: 'Invoice only',
    quoteEstimate: 'Quote / Estimate',
    proformaInvoice: 'Proforma Invoice',
    refund: 'Refund',
    stornoInvoice: 'Storno Invoice',
    creditNoteOnly: 'Credit Note only',
    reportLiquid: 'Report (Liquid only)',
    hideRemovedItems: 'Hide removed/refunded line items',
    location: 'Location',
    locationEmpty: 'Leave empty to use for all locations',
    dangerZone: 'Danger Zone',
    dangerZoneDesc: 'Permanently remove this template from your account.',
    removeTemplate: 'Remove template',
    bodyTemplate: 'Body Template',
    bodyTemplateDesc: 'Uses Mustache or Liquid syntax. Click a snippet:',
    rowTemplate: 'Row Template',
    rowTemplateDesc: 'Rendered once per line item. Click a snippet:',
    variableReference: 'Variable Reference',
    formatCode: 'Format Code',
    insert: 'Insert',
    copy: 'Copy',
    loadModelContinue: 'Load Model & Continue',
    cancel: 'Cancel',
    copilotPlaceholder: 'Try: translate to Romanian, show tax columns, add barcode, use teal palette...',
    trySamplePrompts: 'Try these sample prompts:',
    undo: 'Undo',
    redo: 'Redo',
    aiThinking: 'AI is thinking...',
    proposedChanges: 'Proposed Changes',
    applyChanges: 'Apply Changes',
    dismiss: 'Dismiss',
    aiEngineReady: 'AI Engine ready',
    loadingAiModel: 'Loading AI model...',
    aiEngineOff: 'AI Engine off —',
    loadForAdvanced: 'load for advanced edits',
    instantCommands: 'translate, show/hide sections, add snippets, change font/colors/paper',
    aiEngineDesc: 'structural HTML edits, layout changes, custom modifications',
    aiLocalDesc: 'Model runs locally via WebGPU — no data leaves your browser. Larger models are more accurate but use more VRAM.',
    aiUpgradeDesc: 'upgrade to Starter or Professional to unlock advanced AI template editing.',
    upgrade: 'Upgrade',
    loadAiQuestion: 'Load AI Engine?',
    loadAiDesc: 'The on-device AI model will download and run locally using WebGPU. This requires ~1-3 GB of free VRAM/RAM and a modern GPU (M1+ Mac, or discrete GPU on Windows/Linux).',
  },
};



// WEBPACK FOOTER //
// app/intl/locales/no.js